import '../../style/carouselPerView.css';
import { BureauMemberCard } from './BureauMemberCard';
import organigrammeImage from '../../images/organigramme-hydreaulys.png';

import presidentImage from '../../images/Bureau/president-hamonic.jpg';
import vp1Image from '../../images/Bureau/vp1-brau.jpg';
import vp2Image from '../../images/Bureau/vp2-delaronciere.jpg';
import vp3Image from '../../images/Bureau/vp3-bastoni.jpg';
import vp4Image from '../../images/Bureau/vp4-delamaire.jpg';
import vp5Image from '../../images/Bureau/vp5-rivaud.jpg';
import vp6Image from '../../images/Bureau/vp6-michel.jpg';
import vp7Image from '../../images/Bureau/vp7-chevalier.jpg';
import vp8Image from '../../images/Bureau/vp8-brillault.jpg';
import vp9Image from '../../images/Bureau/vp9-coquard.jpg';
import assesseurPoullennecImage from '../../images/Bureau/assesseur-poullennec.jpg';
import assesseurMasseronImage from '../../images/Bureau/assesseur-masseron.jpg';

import Aos from 'aos';
import { useEffect } from 'react';
import { FaUsers } from 'react-icons/fa';
import { Avatar, AvatarImage } from '../ui/avatar';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogTrigger } from '../ui/dialog';

const vicePresidents = [
  {
    id: '1',
    name: 'Sonia BRAU',
    post: '1ère Vice-présidente',
    desc: 'Suivi et contrôle du contrat de Délégation de Service Public',
    avatar: vp1Image,
  },
  {
    id: '2',
    name: 'Grégoire DE LA RONCIERE',
    post: '2e Vice-Président',
    desc: 'Finance',
    avatar: vp2Image,
  },
  {
    id: '3',
    name: 'Catherine BASTONI',
    post: '3e Vice-présidente',
    desc: 'Transition écologique et énergétique, Innovations durables',
    avatar: vp3Image,
  },
  {
    id: '4',
    name: 'Michel DELAMAIRE',
    post: '4e Vice-Président',
    desc: "Etudes et Travaux pour la gestion du bassin versant du ru de Gally (GEMAPI) et la Protection de l'environnement",
    avatar: vp4Image,
  },
  {
    id: '5',
    name: 'Richard RIVAUD',
    post: '5e Vice-Président',
    desc: 'Etudes, Travaux et Prospective territorial pour la compétence Assainissement communal (Collecte)',
    avatar: vp5Image,
  },
  {
    id: '6',
    name: 'Thierry MICHEL',
    post: '6e Vice-Président',
    desc: "Passation et Exécution des marchés publics et de l'urbanisme/patrimoine foncier",
    avatar: vp6Image,
  },
  {
    id: '7',
    name: 'Pierre CHEVALIER',
    post: '7e Vice-Président',
    desc: 'Communication et lien ressources humaines',
    avatar: vp7Image,
  },
  {
    id: '8',
    name: 'Philippe BRILLAULT',
    post: '8e Vice-Président',
    desc: "Etudes et travaux pour la compétence Traitement des stations d'épuration Carré de Réunion et Val de Gally",
    avatar: vp8Image,
  },
  {
    id: '9',
    name: 'Bertrand COQUARD',
    post: '9e Vice-Président',
    desc: 'Etudes et travaux pour la compétence Transport',
    avatar: vp9Image,
  },
];

const assesseurs = [
  {
    id: '10',
    name: 'Gwilherm POULLENNEC',
    post: 'Assesseur',
    avatar: assesseurPoullennecImage,
  },
  {
    id: '11',
    name: 'Jean-Dominique MASSERON',
    post: 'Assesseur',
    avatar: assesseurMasseronImage,
  },
];

function TeamSection() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <div className="">
        <div className="container">
          <div id="mot-du-president" className="py-12 scroll-mt-24">
            <div className="max-w-3xl px-4 mx-auto">
              <div className="flex gap-4 p-6 border-l-4 md:p-8 bg-gray-50 rounded-2xl border-primary">
                <span className="text-4xl leading-none shrink-0 text-primary/30">“</span>
                <div>
                  <p className="text-base leading-relaxed text-gray-700">
                    Notre responsabilité est de préparer notre territoire aux effets du changement
                    climatique et d’apporter des réponses concrètes en matière de gestion des
                    milieux aquatiques et de prévention des inondations.
                    <br />
                    <br />
                    Avec les élus et les équipes d’Hydreaulys, nous nous engageons à faire de
                    l’assainissement un véritable vecteur de transition écologique et énergétique,
                    au service de la qualité de l’eau, de la préservation de notre environnement et
                    de la santé publique.
                  </p>
                  <div className="flex items-center gap-3 mt-5">
                    <div className="flex items-center justify-center w-10 h-10 text-sm font-semibold text-white rounded-full bg-primary shrink-0">
                      JH
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">Jean-Baptiste HAMONIC</p>
                      <p className="text-xs text-gray-500">Président d’Hydreaulys</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="bureau" className="inline-flex items-center justify-center gap-[12px] relative flex-[0_0_auto] scroll-mt-24">
            <div className="relative w-fit mt-[-1.00px] [font-family:'Roboto',Helvetica] font-bold text-[#242424] text-[25px] text-center tracking-[0] leading-[normal] whitespace-nowrap">
              Bureau
            </div>
            <div className="relative w-[410px] h-px bg-primary" />
          </div>

          <div className="flex flex-col items-center gap-6 p-8 mt-8 text-center shadow-lg bg-primary rounded-2xl sm:flex-row sm:text-left">
            <Avatar className="w-[140px] h-[140px] ring-4 ring-white/20 shrink-0">
              <AvatarImage alt="Jean-Baptiste HAMONIC" src={presidentImage} className="object-cover object-top" />
            </Avatar>
            <div>
              <p className="text-2xl font-bold text-white">Jean-Baptiste HAMONIC</p>
              <span className="inline-block px-3 py-1 mt-2 text-sm font-semibold rounded-full bg-white/15 text-white">
                Président
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 mt-8 sm:grid-cols-2 lg:grid-cols-3">
            {vicePresidents.map((item) => (
              <BureauMemberCard
                key={item.id}
                avatar={item.avatar}
                name={item.name}
                role={item.post}
                desc={item.desc}
              />
            ))}
          </div>

          <h3 id="assesseurs" className="mt-12 mb-6 text-lg font-semibold text-center text-gray-800 scroll-mt-24">
            Assesseurs
          </h3>
          <div className="grid max-w-2xl grid-cols-1 gap-6 mx-auto sm:grid-cols-2">
            {assesseurs.map((item) => (
              <BureauMemberCard
                key={item.id}
                avatar={item.avatar}
                name={item.name}
                role={item.post}
              />
            ))}
          </div>
        </div>

        <div className="container">
          <div id="equipe" className="mt-10 scroll-mt-24">
            <div className="inline-flex items-center justify-center gap-[12px] relative flex-[0_0_auto]">
              <div className=" relative   mt-[-1.00px] [font-family:'Roboto',Helvetica] font-bold text-[#242424] text-[25px] text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Notre Équipe
              </div>

              <div className="relative w-[410px] h-px bg-primary" />
            </div>
          </div>

          <Dialog>
            <div className="max-w-2xl p-6 mx-auto mt-8 text-center border border-gray-200 shadow-sm bg-gray-50 rounded-2xl">
              <img
                src={organigrammeImage}
                alt="Organigramme de l'équipe Hydreaulys"
                className="w-full mx-auto rounded-lg"
              />
              <p className="mt-4 text-sm text-gray-500">
                Direction, pôles et services de l’équipe Hydreaulys
              </p>
              <DialogTrigger asChild>
                <Button className="mt-4">
                  <FaUsers className="w-5 h-5 mr-2" />
                  Voir l'organigramme en plein écran
                </Button>
              </DialogTrigger>
            </div>
            <DialogContent className="max-w-[95vw] max-h-[90vh] overflow-auto p-4">
              <img
                src={organigrammeImage}
                alt="Organigramme de l'équipe Hydreaulys"
                className="min-w-[900px] w-full mx-auto"
              />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  );
}

export default TeamSection;
